export default "__VITE_ASSET__CPBytugQ__"